module.exports = __webpack_public_path__ + "img/03.8011b47f.jpg";